import { WithDestroy } from 'src/app/shared/utils/mixins/withDestroy';
import { NgClass, NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, combineLatest, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IOrgStandard, OrgFrameworksService } from 'src/app/services/org-frameworks.service';

@Component({
    selector: 'app-org-standards-selector',
    templateUrl: './org-standards-selector.component.html',
    styleUrls: ['./org-standards-selector.component.scss'],
    imports: [NgClass, FormsModule, ReactiveFormsModule, NgSelectModule, NgFor]
})
export class OrgStandardsSelectorComponent extends WithDestroy() implements OnInit {
  @Input() control: FormControl;
  @Input() resourceID?: string;
  @Input() headerClass: string = 'text-neutral-800 f-small';
  enabledOrgStandards: IOrgStandard[];
  enabledResourceOrgStandardIDs: string[];

  constructor(
    private orgFrameworksService: OrgFrameworksService,
  ){
    super();
  }

  ngOnInit(): void {
    let getTappedOrgStandards$: Observable<string[]>;
    if(this.resourceID){
      getTappedOrgStandards$ = this.orgFrameworksService.getOrgStandardsByResourceID(this.resourceID).pipe(map(orgStandards => orgStandards.map(s => s.standardID)));
    } else {
      getTappedOrgStandards$ = of(this.control.value);
    }
    combineLatest([this.orgFrameworksService.getEnabledOrgStandards(), getTappedOrgStandards$])
    .pipe(take(1)).subscribe(([enabledOrgStandards, enabledResourceOrgStandard])=>{
        this.enabledOrgStandards = enabledOrgStandards;
        this.enabledResourceOrgStandardIDs = enabledResourceOrgStandard;
        this.control.patchValue(this.control.value?.filter(orgStandardID => {
          return this.enabledOrgStandards.find(s => s.standardID === orgStandardID)}), {emitEvent: false});
    })
  }

  onClearAllOrgStandards() {
    this.control.patchValue([], {emitEvent: false});
  }

  getEnabledOrgStandards(orgStandards: IOrgStandard[]): any[] {
    return orgStandards;
  }

}
